module.exports = __webpack_public_path__ + "static/media/fishing-big.1085d507.jpg";